import http from '@/communication/AuthConnection'

export default async ({ state }, payload) => {
  try {
    const request = await http.get('/v1/board')
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/board/list-boards/index.js